export default __webpack_public_path__ + "static/media/instagram.1c374756.svg";